var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    {
      staticClass: "page",
      attrs: { title: _vm.$t("Webheader.sdd_global_settings") },
    },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _vm.activateSpinner
            ? _c("spinner")
            : _c(
                "div",
                [
                  _c(
                    "div",
                    { staticClass: "mt-0" },
                    [
                      _c(
                        "b-row",
                        { staticClass: "text-xl-start mb-1" },
                        [
                          _c(
                            "b-col",
                            {
                              attrs: {
                                xl: "9",
                                lg: "12",
                                md: "12",
                                cols: "12",
                              },
                            },
                            [
                              _c(
                                "b-button-group",
                                { staticClass: "mt-3 mt-sm-0" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "px-4",
                                      attrs: {
                                        variant:
                                          _vm.superTab === "global"
                                            ? "primary btn-selected"
                                            : "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.superTab = "global"
                                        },
                                      },
                                    },
                                    [_vm._v("Global")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "px-4",
                                      attrs: {
                                        variant:
                                          _vm.superTab === "core"
                                            ? "primary btn-selected"
                                            : "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.superTab = "core"
                                        },
                                      },
                                    },
                                    [_vm._v("Core")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "px-4",
                                      attrs: {
                                        variant:
                                          _vm.superTab === "b2b"
                                            ? "primary btn-selected"
                                            : "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.superTab = "b2b"
                                        },
                                      },
                                    },
                                    [_vm._v("B2B")]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "mb-2" }),
                              _vm._v(" "),
                              _c(
                                "b-button-group",
                                { staticClass: "mt-2 mt-sm-0" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "px-4",
                                      attrs: {
                                        variant:
                                          _vm.tabName === 0
                                            ? "primary btn-selected"
                                            : "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.tabName = 0
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("settings.global_label"))
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.canSeeMandate
                                    ? _c(
                                        "b-button",
                                        {
                                          staticClass: "px-4",
                                          attrs: {
                                            variant:
                                              _vm.tabName === 1
                                                ? "primary btn-selected"
                                                : "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.tabName = 1
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("settings.mandate_label")
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.canSeeCollection
                                    ? _c(
                                        "b-button",
                                        {
                                          staticClass: "px-4",
                                          attrs: {
                                            variant:
                                              _vm.tabName === 2
                                                ? "primary btn-selected"
                                                : "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.tabName = 2
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "settings.collection_label"
                                              )
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.canSeeSRTP
                                    ? _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            variant:
                                              _vm.tabName === 3
                                                ? "primary"
                                                : "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.tabName = 3
                                              _vm.resetSettings()
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("settings.eba_label"))
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.canSeeHRTP
                                    ? _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            variant:
                                              _vm.tabName === 4
                                                ? "primary"
                                                : "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.tabName = 4
                                              _vm.resetSettings()
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("settings.giro_label")
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.canSeePSD2
                                    ? _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            variant:
                                              _vm.tabName === 5
                                                ? "primary"
                                                : "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.tabName = 5
                                              _vm.resetSettings()
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("common.norm.psd2"))
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tabs",
                    {
                      staticClass: "mt-3",
                      attrs: { "nav-class": "d-none" },
                      model: {
                        value: _vm.tabName,
                        callback: function ($$v) {
                          _vm.tabName = $$v
                        },
                        expression: "tabName",
                      },
                    },
                    [
                      _c(
                        "b-tab",
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "mb-3 mt-3",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c("form-write-group-label-input", {
                                    key: "maxLine" + _vm.resetInput,
                                    attrs: {
                                      disabled: !_vm.doesEdit,
                                      maxLength: 21,
                                      inputType: "number",
                                      inputLabel: _vm.$t(
                                        "settings.max_lines_export"
                                      ),
                                      horizontal: "",
                                    },
                                    model: {
                                      value: _vm.settings["NbMaxDowloadData"],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.settings,
                                          "NbMaxDowloadData",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "settings['NbMaxDowloadData']",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tab",
                        [
                          _c(
                            "form-accordion",
                            {
                              staticClass: "ml-2",
                              attrs: {
                                title: _vm.$t("settings.mandates_archive"),
                                isTitleUpperCase: false,
                              },
                            },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-4 ml-4",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "justify-content-around d-flex justify-content-between align-items-center",
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "col-5 d-flex align-items-center sdd-label-main",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "settings.sdd_archive_freq"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "d-flex col-7" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-content-around mr-2",
                                                },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("common.year")
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.sddMandateArchiveFrequenceYear,
                                                          expression:
                                                            "sddMandateArchiveFrequenceYear",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control sdd-select",
                                                      attrs: {
                                                        disabled: !_vm.doesEdit,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.sddMandateArchiveFrequenceYear =
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                        },
                                                      },
                                                    },
                                                    _vm._l(11, function (n) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: n - 1,
                                                          domProps: {
                                                            value: String(
                                                              n - 1
                                                            ),
                                                          },
                                                        },
                                                        [_vm._v(_vm._s(n - 1))]
                                                      )
                                                    }),
                                                    0
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-content-around mr-2",
                                                },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("common.month")
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.sddMandateArchiveFrequenceMonth,
                                                          expression:
                                                            "sddMandateArchiveFrequenceMonth",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control sdd-select",
                                                      attrs: {
                                                        disabled: !_vm.doesEdit,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.sddMandateArchiveFrequenceMonth =
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                        },
                                                      },
                                                    },
                                                    _vm._l(12, function (n) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: n - 1,
                                                          domProps: {
                                                            value: String(
                                                              n - 1
                                                            ),
                                                          },
                                                        },
                                                        [_vm._v(_vm._s(n - 1))]
                                                      )
                                                    }),
                                                    0
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-content-around mr-2",
                                                },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("common.day")
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.sddMandateArchiveFrequenceDay,
                                                          expression:
                                                            "sddMandateArchiveFrequenceDay",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control sdd-select",
                                                      attrs: {
                                                        disabled: !_vm.doesEdit,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.sddMandateArchiveFrequenceDay =
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                        },
                                                      },
                                                    },
                                                    _vm._l(31, function (n) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: n - 1,
                                                          domProps: {
                                                            value: String(
                                                              n - 1
                                                            ),
                                                          },
                                                        },
                                                        [_vm._v(_vm._s(n - 1))]
                                                      )
                                                    }),
                                                    0
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-4 ml-4",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "justify-content-around d-flex justify-content-between align-items-center",
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "col-5 d-flex align-items-center sdd-label-main",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "settings.sdd_archive_delay"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "d-flex col-7" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-content-around mr-2",
                                                },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("common.year")
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.sddMandateArchiveDelayYear,
                                                          expression:
                                                            "sddMandateArchiveDelayYear",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control sdd-select",
                                                      attrs: {
                                                        disabled: !_vm.doesEdit,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.sddMandateArchiveDelayYear =
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                        },
                                                      },
                                                    },
                                                    _vm._l(11, function (n) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: n - 1,
                                                          domProps: {
                                                            value: String(
                                                              n - 1
                                                            ),
                                                          },
                                                        },
                                                        [_vm._v(_vm._s(n - 1))]
                                                      )
                                                    }),
                                                    0
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-content-around mr-2",
                                                },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("common.month")
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.sddMandateArchiveDelayMonth,
                                                          expression:
                                                            "sddMandateArchiveDelayMonth",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control sdd-select",
                                                      attrs: {
                                                        disabled: !_vm.doesEdit,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.sddMandateArchiveDelayMonth =
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                        },
                                                      },
                                                    },
                                                    _vm._l(12, function (n) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: n - 1,
                                                          domProps: {
                                                            value: String(
                                                              n - 1
                                                            ),
                                                          },
                                                        },
                                                        [_vm._v(_vm._s(n - 1))]
                                                      )
                                                    }),
                                                    0
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-content-around mr-2",
                                                },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("common.day")
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.sddMandateArchiveDelayDay,
                                                          expression:
                                                            "sddMandateArchiveDelayDay",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control sdd-select",
                                                      attrs: {
                                                        disabled: !_vm.doesEdit,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.sddMandateArchiveDelayDay =
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                        },
                                                      },
                                                    },
                                                    _vm._l(31, function (n) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: n - 1,
                                                          domProps: {
                                                            value: String(
                                                              n - 1
                                                            ),
                                                          },
                                                        },
                                                        [_vm._v(_vm._s(n - 1))]
                                                      )
                                                    }),
                                                    0
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-4 ml-4",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-content-between align-items-center",
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "col-5 d-flex align-items-center sdd-label-main",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "settings.sdd_last_archive"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "col-7" }, [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.sddMandateLastArchive
                                                    ? _vm.sddMandateLastArchive.substring(
                                                        0,
                                                        10
                                                      )
                                                    : ""
                                                )
                                              ),
                                            ]),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "form-accordion",
                            {
                              staticClass: "ml-2",
                              attrs: {
                                title: _vm.$t("settings.mandates_purge"),
                                isTitleUpperCase: false,
                              },
                            },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-4 ml-4",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "justify-content-around d-flex justify-content-between align-items-center",
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "col-5 d-flex align-items-center sdd-label-main",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "settings.sdd_purge_freq"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "d-flex col-7" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-content-around mr-2",
                                                },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("common.year")
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.sddMandatePurgeFrequenceYear,
                                                          expression:
                                                            "sddMandatePurgeFrequenceYear",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control sdd-select",
                                                      attrs: {
                                                        disabled: !_vm.doesEdit,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.sddMandatePurgeFrequenceYear =
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                        },
                                                      },
                                                    },
                                                    _vm._l(11, function (n) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: n - 1,
                                                          domProps: {
                                                            value: String(
                                                              n - 1
                                                            ),
                                                          },
                                                        },
                                                        [_vm._v(_vm._s(n - 1))]
                                                      )
                                                    }),
                                                    0
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-content-around mr-2",
                                                },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("common.month")
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.sddMandatePurgeFrequenceMonth,
                                                          expression:
                                                            "sddMandatePurgeFrequenceMonth",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control sdd-select",
                                                      attrs: {
                                                        disabled: !_vm.doesEdit,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.sddMandatePurgeFrequenceMonth =
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                        },
                                                      },
                                                    },
                                                    _vm._l(12, function (n) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: n - 1,
                                                          domProps: {
                                                            value: String(
                                                              n - 1
                                                            ),
                                                          },
                                                        },
                                                        [_vm._v(_vm._s(n - 1))]
                                                      )
                                                    }),
                                                    0
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-content-around mr-2",
                                                },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("common.day")
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.sddMandatePurgeFrequenceDay,
                                                          expression:
                                                            "sddMandatePurgeFrequenceDay",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control sdd-select",
                                                      attrs: {
                                                        disabled: !_vm.doesEdit,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.sddMandatePurgeFrequenceDay =
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                        },
                                                      },
                                                    },
                                                    _vm._l(31, function (n) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: n - 1,
                                                          domProps: {
                                                            value: String(
                                                              n - 1
                                                            ),
                                                          },
                                                        },
                                                        [_vm._v(_vm._s(n - 1))]
                                                      )
                                                    }),
                                                    0
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-4 ml-4",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "justify-content-around d-flex justify-content-between align-items-center",
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "col-5 d-flex align-items-center sdd-label-main",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "settings.sdd_purge_delay"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "d-flex col-7" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-content-around mr-2",
                                                },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("common.year")
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.sddMandatePurgeDelayYear,
                                                          expression:
                                                            "sddMandatePurgeDelayYear",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control sdd-select",
                                                      attrs: {
                                                        disabled: !_vm.doesEdit,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.sddMandatePurgeDelayYear =
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                        },
                                                      },
                                                    },
                                                    _vm._l(11, function (n) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: n - 1,
                                                          domProps: {
                                                            value: String(
                                                              n - 1
                                                            ),
                                                          },
                                                        },
                                                        [_vm._v(_vm._s(n - 1))]
                                                      )
                                                    }),
                                                    0
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-content-around mr-2",
                                                },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("common.month")
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.sddMandatePurgeDelayMonth,
                                                          expression:
                                                            "sddMandatePurgeDelayMonth",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control sdd-select",
                                                      attrs: {
                                                        disabled: !_vm.doesEdit,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.sddMandatePurgeDelayMonth =
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                        },
                                                      },
                                                    },
                                                    _vm._l(12, function (n) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: n - 1,
                                                          domProps: {
                                                            value: String(
                                                              n - 1
                                                            ),
                                                          },
                                                        },
                                                        [_vm._v(_vm._s(n - 1))]
                                                      )
                                                    }),
                                                    0
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-content-around mr-2",
                                                },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("common.day")
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.sddMandatePurgeDelayDay,
                                                          expression:
                                                            "sddMandatePurgeDelayDay",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control sdd-select",
                                                      attrs: {
                                                        disabled: !_vm.doesEdit,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.sddMandatePurgeDelayDay =
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                        },
                                                      },
                                                    },
                                                    _vm._l(31, function (n) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: n - 1,
                                                          domProps: {
                                                            value: String(
                                                              n - 1
                                                            ),
                                                          },
                                                        },
                                                        [_vm._v(_vm._s(n - 1))]
                                                      )
                                                    }),
                                                    0
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-4 ml-4",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-content-between align-items-center",
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "col-5 d-flex align-items-center sdd-label-main",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "settings.sdd_last_purge"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "col-7" }, [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.sddMandateLastPurge
                                                    ? _vm.sddMandateLastPurge.substring(
                                                        0,
                                                        10
                                                      )
                                                    : ""
                                                )
                                              ),
                                            ]),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tab",
                        [
                          _c(
                            "form-accordion",
                            {
                              staticClass: "ml-2",
                              attrs: {
                                title: _vm.$t("settings.collection_archive"),
                                isTitleUpperCase: false,
                              },
                            },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-4 ml-4",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "justify-content-around d-flex justify-content-between align-items-center",
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "col-5 d-flex align-items-center sdd-label-main",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "settings.sdd_archive_freq"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "d-flex col-7" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-content-around mr-2",
                                                },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("common.year")
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.sddCollectionArchiveFrequenceYear,
                                                          expression:
                                                            "sddCollectionArchiveFrequenceYear",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control sdd-select",
                                                      attrs: {
                                                        disabled: !_vm.doesEdit,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.sddCollectionArchiveFrequenceYear =
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                        },
                                                      },
                                                    },
                                                    _vm._l(11, function (n) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: n - 1,
                                                          domProps: {
                                                            value: String(
                                                              n - 1
                                                            ),
                                                          },
                                                        },
                                                        [_vm._v(_vm._s(n - 1))]
                                                      )
                                                    }),
                                                    0
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-content-around mr-2",
                                                },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("common.month")
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.sddCollectionArchiveFrequenceMonth,
                                                          expression:
                                                            "sddCollectionArchiveFrequenceMonth",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control sdd-select",
                                                      attrs: {
                                                        disabled: !_vm.doesEdit,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.sddCollectionArchiveFrequenceMonth =
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                        },
                                                      },
                                                    },
                                                    _vm._l(12, function (n) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: n - 1,
                                                          domProps: {
                                                            value: String(
                                                              n - 1
                                                            ),
                                                          },
                                                        },
                                                        [_vm._v(_vm._s(n - 1))]
                                                      )
                                                    }),
                                                    0
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-content-around mr-2",
                                                },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("common.day")
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.sddCollectionArchiveFrequenceDay,
                                                          expression:
                                                            "sddCollectionArchiveFrequenceDay",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control sdd-select",
                                                      attrs: {
                                                        disabled: !_vm.doesEdit,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.sddCollectionArchiveFrequenceDay =
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                        },
                                                      },
                                                    },
                                                    _vm._l(31, function (n) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: n - 1,
                                                          domProps: {
                                                            value: String(
                                                              n - 1
                                                            ),
                                                          },
                                                        },
                                                        [_vm._v(_vm._s(n - 1))]
                                                      )
                                                    }),
                                                    0
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-4 ml-4",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "justify-content-around d-flex justify-content-between align-items-center",
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "col-5 d-flex align-items-center sdd-label-main",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "settings.sdd_archive_delay"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "d-flex col-7" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-content-around mr-2",
                                                },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("common.year")
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.sddCollectionArchiveDelayYear,
                                                          expression:
                                                            "sddCollectionArchiveDelayYear",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control sdd-select",
                                                      attrs: {
                                                        disabled: !_vm.doesEdit,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.sddCollectionArchiveDelayYear =
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                        },
                                                      },
                                                    },
                                                    _vm._l(11, function (n) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: n - 1,
                                                          domProps: {
                                                            value: String(
                                                              n - 1
                                                            ),
                                                          },
                                                        },
                                                        [_vm._v(_vm._s(n - 1))]
                                                      )
                                                    }),
                                                    0
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-content-around mr-2",
                                                },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("common.month")
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.sddCollectionArchiveDelayMonth,
                                                          expression:
                                                            "sddCollectionArchiveDelayMonth",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control sdd-select",
                                                      attrs: {
                                                        disabled: !_vm.doesEdit,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.sddCollectionArchiveDelayMonth =
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                        },
                                                      },
                                                    },
                                                    _vm._l(12, function (n) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: n - 1,
                                                          domProps: {
                                                            value: String(
                                                              n - 1
                                                            ),
                                                          },
                                                        },
                                                        [_vm._v(_vm._s(n - 1))]
                                                      )
                                                    }),
                                                    0
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-content-around mr-2",
                                                },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("common.day")
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.sddCollectionArchiveDelayDay,
                                                          expression:
                                                            "sddCollectionArchiveDelayDay",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control sdd-select",
                                                      attrs: {
                                                        disabled: !_vm.doesEdit,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.sddCollectionArchiveDelayDay =
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                        },
                                                      },
                                                    },
                                                    _vm._l(31, function (n) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: n - 1,
                                                          domProps: {
                                                            value: String(
                                                              n - 1
                                                            ),
                                                          },
                                                        },
                                                        [_vm._v(_vm._s(n - 1))]
                                                      )
                                                    }),
                                                    0
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-4 ml-4",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-content-between align-items-center",
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "col-5 d-flex align-items-center sdd-label-main",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "settings.sdd_last_archive"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "col-7" }, [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.sddCollectionLastArchive
                                                    ? _vm.sddCollectionLastArchive.substring(
                                                        0,
                                                        10
                                                      )
                                                    : ""
                                                )
                                              ),
                                            ]),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "form-accordion",
                            {
                              staticClass: "ml-2",
                              attrs: {
                                title: _vm.$t("settings.collection_purge"),
                                isTitleUpperCase: false,
                              },
                            },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-4 ml-4",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "justify-content-around d-flex justify-content-between align-items-center",
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "col-5 d-flex align-items-center sdd-label-main",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "settings.sdd_purge_freq"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "d-flex col-7" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-content-around mr-2",
                                                },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("common.year")
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.sddCollectionPurgeFrequenceYear,
                                                          expression:
                                                            "sddCollectionPurgeFrequenceYear",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control sdd-select",
                                                      attrs: {
                                                        disabled: !_vm.doesEdit,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.sddCollectionPurgeFrequenceYear =
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                        },
                                                      },
                                                    },
                                                    _vm._l(11, function (n) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: n - 1,
                                                          domProps: {
                                                            value: String(
                                                              n - 1
                                                            ),
                                                          },
                                                        },
                                                        [_vm._v(_vm._s(n - 1))]
                                                      )
                                                    }),
                                                    0
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-content-around mr-2",
                                                },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("common.month")
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.sddCollectionPurgeFrequenceMonth,
                                                          expression:
                                                            "sddCollectionPurgeFrequenceMonth",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control sdd-select",
                                                      attrs: {
                                                        disabled: !_vm.doesEdit,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.sddCollectionPurgeFrequenceMonth =
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                        },
                                                      },
                                                    },
                                                    _vm._l(12, function (n) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: n - 1,
                                                          domProps: {
                                                            value: String(
                                                              n - 1
                                                            ),
                                                          },
                                                        },
                                                        [_vm._v(_vm._s(n - 1))]
                                                      )
                                                    }),
                                                    0
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-content-around mr-2",
                                                },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("common.day")
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.sddCollectionPurgeFrequenceDay,
                                                          expression:
                                                            "sddCollectionPurgeFrequenceDay",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control sdd-select",
                                                      attrs: {
                                                        disabled: !_vm.doesEdit,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.sddCollectionPurgeFrequenceDay =
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                        },
                                                      },
                                                    },
                                                    _vm._l(31, function (n) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: n - 1,
                                                          domProps: {
                                                            value: String(
                                                              n - 1
                                                            ),
                                                          },
                                                        },
                                                        [_vm._v(_vm._s(n - 1))]
                                                      )
                                                    }),
                                                    0
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-4 ml-4",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "justify-content-around d-flex justify-content-between align-items-center",
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "col-5 d-flex align-items-center sdd-label-main",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "settings.sdd_purge_delay"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "d-flex col-7" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-content-around mr-2",
                                                },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("common.year")
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.sddCollectionPurgeDelayYear,
                                                          expression:
                                                            "sddCollectionPurgeDelayYear",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control sdd-select",
                                                      attrs: {
                                                        disabled: !_vm.doesEdit,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.sddCollectionPurgeDelayYear =
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                        },
                                                      },
                                                    },
                                                    _vm._l(11, function (n) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: n - 1,
                                                          domProps: {
                                                            value: String(
                                                              n - 1
                                                            ),
                                                          },
                                                        },
                                                        [_vm._v(_vm._s(n - 1))]
                                                      )
                                                    }),
                                                    0
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-content-around mr-2",
                                                },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("common.month")
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.sddCollectionPurgeDelayMonth,
                                                          expression:
                                                            "sddCollectionPurgeDelayMonth",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control sdd-select",
                                                      attrs: {
                                                        disabled: !_vm.doesEdit,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.sddCollectionPurgeDelayMonth =
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                        },
                                                      },
                                                    },
                                                    _vm._l(12, function (n) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: n - 1,
                                                          domProps: {
                                                            value: String(
                                                              n - 1
                                                            ),
                                                          },
                                                        },
                                                        [_vm._v(_vm._s(n - 1))]
                                                      )
                                                    }),
                                                    0
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-content-around mr-2",
                                                },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("common.day")
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.sddCollectionPurgeDelayDay,
                                                          expression:
                                                            "sddCollectionPurgeDelayDay",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control sdd-select",
                                                      attrs: {
                                                        disabled: !_vm.doesEdit,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.sddCollectionPurgeDelayDay =
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                        },
                                                      },
                                                    },
                                                    _vm._l(31, function (n) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: n - 1,
                                                          domProps: {
                                                            value: String(
                                                              n - 1
                                                            ),
                                                          },
                                                        },
                                                        [_vm._v(_vm._s(n - 1))]
                                                      )
                                                    }),
                                                    0
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-4 ml-4",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-content-between align-items-center",
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "col-5 d-flex align-items-center sdd-label-main",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "settings.sdd_last_purge"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "col-7" }, [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.sddCollectionLastPurge
                                                    ? _vm.sddCollectionLastPurge.substring(
                                                        0,
                                                        10
                                                      )
                                                    : ""
                                                )
                                              ),
                                            ]),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
          _vm._v(" "),
          true
            ? _c(
                "div",
                { staticClass: "col-md-10 offset-md-1" },
                [
                  _c(
                    "b-row",
                    { staticClass: "justify-content-end no-gutters" },
                    [
                      _vm.doesEdit
                        ? _c(
                            "div",
                            { staticClass: "pr-2" },
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: { variant: "primary" },
                                  on: { click: _vm.resetSettings },
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("common.cncl"))),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          !_vm.doesEdit
                            ? _c(
                                "b-button",
                                {
                                  attrs: { variant: "primary" },
                                  on: { click: _vm.editSettings },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("administration.edit"))
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.doesEdit
                            ? _c(
                                "b-button",
                                {
                                  attrs: { variant: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateSettings(_vm.settings)
                                    },
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("common.update"))),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }